import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=391849e6&scoped=true"
import script from "./Method.vue?vue&type=script&lang=js"
export * from "./Method.vue?vue&type=script&lang=js"
import style1 from "./Method.vue?vue&type=style&index=1&id=391849e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391849e6",
  null
  
)

export default component.exports